<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Property Details</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">
  
  <div *ngIf="!dataLoaded" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <form [formGroup]="propertyDetails" autocomplete="off" *ngIf="dataLoaded">

    <!-- Sale address same as correspondence -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is the Sale address the same as the correspondence address?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="saleAddressSameAsCorrespondenceAddress" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <!-- Sale address section -->
    <div [hidden]="propertyDetails.controls['saleAddressSameAsCorrespondenceAddress'].value != 0">

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Postcode</label>
          <div class="input-group">
            <input class="form-control" #salePostcode maxlength="10"
              formControlName="salePostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup1"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup1 lookupType="postcode" [searchField]="salePostcode"
        [add1]="propertyDetails.controls['saleAddressLine1']"
        [add2]="propertyDetails.controls['saleAddressLine2']"
        [add3]="propertyDetails.controls['saleAddressLine3']"
        [add4]="propertyDetails.controls['saleAddressLine4']"
        [add5]="propertyDetails.controls['saleAddressLine5']"
        [addPc]="propertyDetails.controls['salePostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="saleAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="saleAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="saleAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="saleAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Sale Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="saleAddressLine5" (change)="updateField()">
        </div>
      </div>

    </div>

    <!-- Property details -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is property Unregistered?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyIsUnregistered" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Title Number</label>
        <input class="form-control" formControlName="titleNumber" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Does the client full legal name match the Title deeds?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="clientFullNameMatchTitleDeeds" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['clientFullNameMatchTitleDeeds'].value != 0">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Reason</label>
          <input class="form-control" formControlName="clientFullNameMatchTitleDeedsReason" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Statement of Truth Regarding Name Discrepancy Required?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="statementOfTruthRegardingNameDiscrepencyRequired" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Property Type</label>
        <select class="form-select" formControlName="propertyType" (change)="updateField()">
          <option [ngValue]="null"></option>
          <option [ngValue]="1">Leasehold</option>
          <option [ngValue]="2">Freehold</option>
        </select>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Title Guarantee Type</label>
        <select class="form-select" formControlName="titleGuaranteeType" (change)="updateField()">
          <option [ngValue]="null"></option>
          <option [ngValue]="1">Full Title Guarantee</option>
          <option [ngValue]="2">Limited Title Guarantee</option>
        </select>
      </div>
    </div>

    <!-- Leasehold section -->
    <div [hidden]="propertyDetails.controls['propertyType'].value != 1">

      <hr class="my-3">
      <h6 class="fw-bold mb-3">Landlord Details</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Full Name</label>
          <input class="form-control" maxlength="100" formControlName="landlordName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Postcode</label>
          <div class="input-group">
            <input class="form-control" #landlordPostcode maxlength="10"
              formControlName="landlordPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup4"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup4 lookupType="postcode" [searchField]="landlordPostcode"
        [add1]="propertyDetails.controls['landlordAddressLine1']"
        [add2]="propertyDetails.controls['landlordAddressLine2']"
        [add3]="propertyDetails.controls['landlordAddressLine3']"
        [add4]="propertyDetails.controls['landlordAddressLine4']"
        [add5]="propertyDetails.controls['landlordAddressLine5']"
        [addPc]="propertyDetails.controls['landlordPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine5" (change)="updateField()">
        </div>
      </div>

      <hr class="my-3">
      <h6 class="fw-bold mb-3">Management Company Details</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Name</label>
          <input class="form-control" formControlName="managementCompanyName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Postcode</label>
          <div class="input-group">
            <input class="form-control" #managementCompanyPostcode maxlength="10"
              formControlName="managementCompanyPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup5"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup5 lookupType="postcode" [searchField]="managementCompanyPostcode"
        [add1]="propertyDetails.controls['managementCompanyAddressLine1']"
        [add2]="propertyDetails.controls['managementCompanyAddressLine2']"
        [add3]="propertyDetails.controls['managementCompanyAddressLine3']"
        [add4]="propertyDetails.controls['managementCompanyAddressLine4']"
        [add5]="propertyDetails.controls['managementCompanyAddressLine5']"
        [addPc]="propertyDetails.controls['managementCompanyPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine5" (change)="updateField()">
        </div>
      </div>

    </div>

    <!-- Solar Panels -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Solar Panels</label>
        <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsPresent" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['solarPanelsPresent'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Are the solar panels owned outright?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsOwnedOutright" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>

      <div [hidden]="propertyDetails.controls['solarPanelsOwnedOutright'].value != 0">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panels Company Name</label>
            <input class="form-control" formControlName="solarPanelsCompany" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Postcode</label>
            <div class="input-group">
              <input class="form-control" #solarPanelsOwnerPostcode maxlength="10"
                formControlName="solarPanelsOwnerPostcode" (change)="updateField()">
              <app-address-lookup-button [for]="addressLookup2"></app-address-lookup-button>
            </div>
          </div>
        </div>

        <app-address-lookup #addressLookup2 lookupType="postcode" [searchField]="solarPanelsOwnerPostcode"
          [add1]="propertyDetails.controls['solarPanelsOwnerAddressLine1']"
          [add2]="propertyDetails.controls['solarPanelsOwnerAddressLine2']"
          [add3]="propertyDetails.controls['solarPanelsOwnerAddressLine3']"
          [add4]="propertyDetails.controls['solarPanelsOwnerAddressLine4']"
          [add5]="propertyDetails.controls['solarPanelsOwnerAddressLine5']"
          [addPc]="propertyDetails.controls['solarPanelsOwnerPostcode']"
          (change)="updateField()">
        </app-address-lookup>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Address Line 1</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine1" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Address Line 2</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine2" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Address Line 3</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine3" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Address Line 4</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine4" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Address Line 5</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine5" (change)="updateField()">
          </div>
        </div>
      </div>
    </div>

    <!-- Septic Tank / Redeem Mortgage -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Septic Tank</label>
        <app-yes-no-form-toggle class="d-block" formControlName="hasSepticTank" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Redeem Mortgage</label>
        <app-yes-no-form-toggle class="d-block" formControlName="redeemMortgage" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <!-- Lender 1 -->
    <div [hidden]="propertyDetails.controls['redeemMortgage'].value != 1">
      <hr class="my-3">
      <h6 class="fw-bold mb-3">Lender 1</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Current Lender Name</label>
          <input class="form-control" maxlength="100" formControlName="lenderName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Postcode</label>
          <div class="input-group">
            <input class="form-control" #lenderPostcode maxlength="10"
              formControlName="lenderPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup6"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup6 lookupType="postcode" [searchField]="lenderPostcode"
        [add1]="propertyDetails.controls['lenderAddressLine1']"
        [add2]="propertyDetails.controls['lenderAddressLine2']"
        [add3]="propertyDetails.controls['lenderAddressLine3']"
        [add4]="propertyDetails.controls['lenderAddressLine4']"
        [add5]="propertyDetails.controls['lenderAddressLine5']"
        [addPc]="propertyDetails.controls['lenderPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine5" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Redemption Amount</label>
          <div class="input-group">
            <span class="input-group-text">£</span>
            <input class="form-control" formControlName="redemptionAmount" (change)="updateField()" type="number">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Current Mortgage Account Number</label>
          <input class="form-control" maxlength="100" formControlName="currentMortgageAccountNumber" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender1" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>

      <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender1'].value != 1">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender Sort Code</label>
            <input class="form-control" maxlength="100" formControlName="lender1SortCode" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender Account Number</label>
            <input class="form-control" maxlength="100" formControlName="lender1AccountNumber" (change)="updateField()">
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Is there a second lender?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="hasSecondLender" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>

      <!-- Lender 2 -->
      <div [hidden]="propertyDetails.controls['hasSecondLender'].value != 1">
        <hr class="my-3">
        <h6 class="fw-bold mb-3">Lender 2</h6>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Name</label>
            <input class="form-control" maxlength="100" formControlName="lender2Name" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Postcode</label>
            <div class="input-group">
              <input class="form-control" #lender2Postcode maxlength="10"
                formControlName="lender2Postcode" (change)="updateField()">
              <app-address-lookup-button [for]="addressLookup7"></app-address-lookup-button>
            </div>
          </div>
        </div>

        <app-address-lookup #addressLookup7 lookupType="postcode" [searchField]="lender2Postcode"
          [add1]="propertyDetails.controls['lender2AddressLine1']"
          [add2]="propertyDetails.controls['lender2AddressLine2']"
          [add3]="propertyDetails.controls['lender2AddressLine3']"
          [add4]="propertyDetails.controls['lender2AddressLine4']"
          [add5]="propertyDetails.controls['lender2AddressLine5']"
          [addPc]="propertyDetails.controls['lender2Postcode']"
          (change)="updateField()">
        </app-address-lookup>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Address Line 1</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine1" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Address Line 2</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine2" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Address Line 3</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine3" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Address Line 4</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine4" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Address Line 5</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine5" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Redemption Amount</label>
            <div class="input-group">
              <span class="input-group-text">£</span>
              <input class="form-control" formControlName="redemptionAmount2" (change)="updateField()" type="number">
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender2" (change)="updateField()"></app-yes-no-form-toggle>
          </div>
        </div>

        <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender2'].value != 1">
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 2 Sort Code</label>
              <input class="form-control" maxlength="100" formControlName="lender2SortCode" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 2 Account Number</label>
              <input class="form-control" maxlength="100" formControlName="lender2AccountNumber" (change)="updateField()">
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Is there a third lender?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="hasThirdLender" (change)="updateField()"></app-yes-no-form-toggle>
          </div>
        </div>

        <!-- Lender 3 -->
        <div [hidden]="propertyDetails.controls['hasThirdLender'].value != 1">
          <hr class="my-3">
          <h6 class="fw-bold mb-3">Lender 3</h6>

          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Name</label>
              <input class="form-control" maxlength="100" formControlName="lender3Name" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Postcode</label>
              <div class="input-group">
                <input class="form-control" #lender3Postcode maxlength="10"
                  formControlName="lender3Postcode" (change)="updateField()">
                <app-address-lookup-button [for]="addressLookup8"></app-address-lookup-button>
              </div>
            </div>
          </div>

          <app-address-lookup #addressLookup8 lookupType="postcode" [searchField]="lender3Postcode"
            [add1]="propertyDetails.controls['lender3AddressLine1']"
            [add2]="propertyDetails.controls['lender3AddressLine2']"
            [add3]="propertyDetails.controls['lender3AddressLine3']"
            [add4]="propertyDetails.controls['lender3AddressLine4']"
            [add5]="propertyDetails.controls['lender3AddressLine5']"
            [addPc]="propertyDetails.controls['lender3Postcode']"
            (change)="updateField()">
          </app-address-lookup>

          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Address Line 1</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine1" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Address Line 2</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine2" (change)="updateField()">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Address Line 3</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine3" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Address Line 4</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine4" (change)="updateField()">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Address Line 5</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine5" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Redemption Amount</label>
              <div class="input-group">
                <span class="input-group-text">£</span>
                <input class="form-control" formControlName="redemptionAmount3" (change)="updateField()" type="number">
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
              <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender3" (change)="updateField()"></app-yes-no-form-toggle>
            </div>
          </div>

          <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender3'].value != 1">
            <div class="row mb-3">
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Lender 3 Sort Code</label>
                <input class="form-control" maxlength="100" formControlName="lender3SortCode" (change)="updateField()">
              </div>
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Lender 3 Account Number</label>
                <input class="form-control" maxlength="100" formControlName="lender3AccountNumber" (change)="updateField()">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Transfer of Title / Removal -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Transfer of Title into Joint Names</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertySoleNameTransferIntoJointNames" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['propertySoleNameTransferIntoJointNames'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Reason</label>
          <input class="form-control" formControlName="propertySoleNameTransferIntoJointNamesReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Removing A Name From Title Required</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyJointNameTransferIntoSoleName" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['propertyJointNameTransferIntoSoleName'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Details/Reason</label>
          <input class="form-control" formControlName="propertyJointNameTransferIntoSoleNameReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Removal of restriction</label>
        <app-yes-no-form-toggle class="d-block" formControlName="removalOfRestriction" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['removalOfRestriction'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Details/Reason</label>
          <input class="form-control" formControlName="removalOfRestrictionReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Sale price / Chattels -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Agreed Sale Price</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="agreedSalePrice" (change)="updateField()">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Chattels</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="chattels" (change)="updateField()">
        </div>
      </div>
    </div>

    <app-allowance [caseId]="caseId"></app-allowance>

    <!-- Buyer Solicitor -->
    <hr class="my-3">
    <h6 class="fw-bold mb-3">Buyer Solicitor</h6>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Name</label>
        <input class="form-control" formControlName="buyerSolicitorName" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Email Address</label>
        <input class="form-control" formControlName="buyerSolicitorEmailAddress" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Contact Number</label>
        <input class="form-control" formControlName="buyerSolicitorContactNumber" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Reference</label>
        <input class="form-control" formControlName="buyerSolicitorReference" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Postcode</label>
        <div class="input-group">
          <input class="form-control" #buyerSolicitorPostcode maxlength="10"
            formControlName="buyerSolicitorPostcode" (change)="updateField()">
          <app-address-lookup-button [for]="addressLookup9"></app-address-lookup-button>
        </div>
      </div>
    </div>

    <app-address-lookup #addressLookup9 lookupType="postcode" [searchField]="buyerSolicitorPostcode"
      [add1]="propertyDetails.controls['buyerSolicitorAddressLine1']"
      [add2]="propertyDetails.controls['buyerSolicitorAddressLine2']"
      [add3]="propertyDetails.controls['buyerSolicitorAddressLine3']"
      [add4]="propertyDetails.controls['buyerSolicitorAddressLine4']"
      [add5]="propertyDetails.controls['buyerSolicitorAddressLine5']"
      [addPc]="propertyDetails.controls['buyerSolicitorPostcode']"
      (change)="updateField()">
    </app-address-lookup>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Address Line 1</label>
        <input class="form-control" maxlength="100" formControlName="buyerSolicitorAddressLine1" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Address Line 2</label>
        <input class="form-control" maxlength="100" formControlName="buyerSolicitorAddressLine2" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Address Line 3</label>
        <input class="form-control" maxlength="100" formControlName="buyerSolicitorAddressLine3" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Address Line 4</label>
        <input class="form-control" maxlength="100" formControlName="buyerSolicitorAddressLine4" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer Solicitor Address Line 5</label>
        <input class="form-control" maxlength="100" formControlName="buyerSolicitorAddressLine5" (change)="updateField()">
      </div>
    </div>

    <!-- Buyer Names -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer 1 Name</label>
        <input class="form-control" formControlName="buyer1Name" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Buyer 2 Name</label>
        <input class="form-control" formControlName="buyer2Name" (change)="updateField()">
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="openEstateAgent()">Next</button>
</div>